import { createFileRoute } from "@tanstack/react-router";
import { AlertsListPage } from "../../../components/alerts/AlertsListPage";
import { requireModuleAccess, MODULE_WORKSPACE } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/workspace/alerts/")({
  beforeLoad: requireModuleAccess(MODULE_WORKSPACE),
  component: AlertsListPage,
});
